import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    organizationSponsorships: {},
    selectedOrganizationSponsorshipId:''
};


const organizationSponsorships = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_ORGANIZATION_SPONSORSHIP_LIST: {
      draft.organizationSponsorships = payload?.organizationSponsorships;
      break;
    }

    case Actions.SELECTED_ORGANIZATION_SPONSORSHIP_ID: {
      draft.selectedOrganizationSponsorshipId = payload?.selectedOrganizationSponsorshipId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default organizationSponsorships;
